import { match } from 'react-router-dom';

import EducationEditorStore from '../../stores/EducationEditorStore';
import JobHistoryEditorStore from '../../stores/JobHistoryEditorStore';
import SelfEvaluationScoreEditorStore from '../../stores/SelfEvaluationEditorStore';
import UserInfoStore from '../../stores/UserInfoStore';
import UserStore from '../../stores/UserStore';

export enum Gender {
  FEMALE = 'Female',
  MALE = 'Male',
  OTHER = 'Other'
}

export enum UserType {
  MENTEE = 'mentee',
  MENTOR = 'mentor'
}

export interface Education {
  id?: number,
  degree: string,
  gradYear : number,
  major: string,
  school: string
}

export interface SelfEvaluation {
  id: number,
  programId: number,
  programName: string,
  score: number
}

export interface JobHistory {
  id?: number,
  category: string,
  level: string,
  title: string,
  years: number
}

export interface UserInfoProps {
  match: match<{ userType: string }>,
  history: any,
  userInfoStore?: UserInfoStore,
  userStore?: UserStore
}

export interface StepsCommonProps {
  userInfoStore?: UserInfoStore
}

export interface EducationEditorProps {
  educationEditorStore?: EducationEditorStore
}

export interface JobHistoryEditorProps {
  jobHistoryEditorStore?: JobHistoryEditorStore
}

export interface SelfEvaluationEditorProps {
  selfEvaluationEditorStore?: SelfEvaluationScoreEditorStore
}



// WEBPACK FOOTER //
// ./src/types/pages/UserInfo.ts